import { createSelector } from "reselect";

const selectExamGroup = (state) => state.examGroup;

export const selectAllExamGroups = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.allExamGroups
);

export const selectGroupDetails = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.singleGroup
);

export const selectLoadingGroupDetails = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.isLoadingGroup
);

export const selectExamGroupLoading = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.isLoading
);

export const selectIsEditingGroup = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.isEditingGroup
);

export const selectIsCreatingGroup = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.isCreatingGroup
);

export const selectEditMode = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.editMode
);

export const selectEditData = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.editData
);

export const selectCurrentExamGroup = createSelector(
  [selectExamGroup],
  (examGroup) => examGroup.currentExamGroup
);
